import { buildM365ChatUrl, type Prompt } from "@1js/pl-card-components";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { type HandoffCallbackResult } from "../hooks/handoff.types";
import type { SendApiActionEventParameter } from "../utils/Telemetry";
import { createPromptLink } from "./prompt-client.web";

export type M365Destination = "M365Chat" | "Teams";
export type ChatType = "web" | "work";

const host = window.location.host;

/**
 * Handles handoff to M365 Chat service, to try prompts in M365 Chat, or Teams.
 * @param promptText - The prompt command text to handoff
 * @param _destination - The destination product or service to handoff the prompt to
 * @param onSuccess - The callback to call when handoff is successful
 * @param onError - The callback to call when handoff fails
 * @param chatType - The type of chat(tab in Business  Chat app) to handoff to, e.g. web, work
 */
export const handoffToM365Chat = async (
  prompt: Prompt,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _destination: M365Destination,
  isTryInAppendM365ChatFeatures: boolean,
  isTryIn1_2Format: boolean,
  isTryIn3SPromptLinkEnabled: boolean,
  onSendApiActionEvent: (params: SendApiActionEventParameter) => void,
  msalContext?: IPublicClientApplication,
  chatType?: ChatType,
  isBizChatTryInTeamsAppEnabled?: boolean
): Promise<HandoffCallbackResult> => {
  let handoffUrl = "";
  if (isTryIn3SPromptLinkEnabled) {
    const serviceGeneratedLinkId = await createPromptLink(
      host,
      prompt,
      onSendApiActionEvent,
      msalContext,
      "tryInApp"
    );
    handoffUrl = buildM365ChatUrl({
      prompt,
      scenario: "tryInApp",
      serviceGeneratedLinkId: serviceGeneratedLinkId.PromptEncodedLink,
      clickTimestamp: undefined,
      chatType,
      isAppendM365ChatFeatures: isTryInAppendM365ChatFeatures,
      source: "CopilotLab",
      isTryIn1_2Format,
      isBizChatTryInTeamsAppEnabled,
    });
  } else {
    handoffUrl = buildM365ChatUrl({
      prompt,
      scenario: "tryInApp",
      serviceGeneratedLinkId: undefined,
      removeHtmlTags: false,
      newFormat: true,
      clickTimestamp: undefined,
      chatType,
      isAppendM365ChatFeatures: isTryInAppendM365ChatFeatures,
      source: "CopilotLab",
      isTryIn1_2Format,
      isBizChatTryInTeamsAppEnabled,
    });
  }
  if (handoffUrl === "") {
    throw new Error("HandoffPromptNotValid");
  }

  return { handoffUrl };
};
